import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { has } from 'lodash';

const initialState = {
  date: new Date(),
  place: {},
  placeSite: '',
  equipment: {},
  equipmentService: {},
  questions: [],
  totalQuestions: 0,
  description: '',
  oldActions: [],
  loadingActions: false,
};

const clearServiceForm = (state, action) => {
  return updateObject(state, { ...initialState });
}

const setDateServiceForm = (state, action) => {
  return updateObject(state, {
    date: action.date
  });
}

const setDescriptionServiceForm = (state, action) => {
  return updateObject(state, {
    description: action.description
  });
}

const changeSiteServiceForm = (state, action) => {
  return updateObject(state, {
    place: {},
    placeSite: '',
    equipment: {},
    equipmentService: {},
    questions: [],
  });
}

const setPlaceServiceForm = (state, action) => {
  return updateObject(state, {
    place: action.place,
    placeSite: action.site,
    equipment: {},
    equipmentService: {},
    questions: [],
  });
}
// novo reducer p/ quando já tiver equipamento selecionado
const setPlaceServiceFormEquipment = (state, action) => {
  return updateObject(state, {
    place: action.place,
    placeSite: action.site,
    equipmentService: {},
    questions: [],
  });
}

const setEquipmentServiceForm = (state, action) => {
  return updateObject(state, {
    equipment: action.equipment,
    equipmentService: {},
    questions: [],
  });
}

const setEquipmentServiceServiceForm = (state, action) => {
  return updateObject(state, {
    equipmentService: action.equipmentService
  });
}

const populateQuestionsServiceForm = (state, action) => {
  const defaultAnswer = action.shouldAnswerWithNA ? 'NA' : '';
  const questionArray = action.questions.filter(question => question.site === state.placeSite);
  let totalQuestions = 0;
  questionArray.map(question => {
    if (question.type === 'question') {
      question.answer = defaultAnswer;
      totalQuestions += 1;
    } else {
      question.answer = 'NA';
      question.weight = null;
    }
    question.actions = [];
    return question;
  });

  return updateObject(state, { questions: questionArray, totalQuestions });
};

const populateEditQuestionsServiceForm = (state, action) => {
  const questionArray = action.questions;
  questionArray.forEach(question => {
    if (!(has(question, 'actions'))) question.actions = [];
  });
  return updateObject(state, { questions: questionArray });
};

const answerQuestionServiceForm = (state, action) => {
  const questionsClone = [...state.questions]
  const index = questionsClone.findIndex(q => q._id === action.question._id)
  questionsClone[index].answer = action.answer


  return updateObject(state, {
    questions: questionsClone
  });
};

const answerAllQuestionWithNA = (state) => {
  const questionsClone = [...state.questions]
  questionsClone.forEach(q => q.answer = 'NA');

  return updateObject(state, {
    questions: questionsClone
  });
};

const commentQuestionServiceForm = (state, action) => {
  const questionsClone = [...state.questions]
  const index = questionsClone.findIndex(q => q._id === action.question._id)
  questionsClone[index].comment = action.comment

  return updateObject(state, {
    questions: questionsClone
  });
};

const addFileQuestionServiceForm = (state, action) => {
  const questionsClone = [...state.questions]
  const index = questionsClone.findIndex((question) => question._id === action.questionId)
  if (questionsClone[index].files) questionsClone[index].files = [...questionsClone[index].files, ...action.files];
  else questionsClone[index].files = action.files;
  

  return updateObject(state, {
    questions: questionsClone
  });
}

const editFileQuestionServiceForm = (state, action) => {
  const questionsClone = [...state.questions]
  const index = questionsClone.findIndex((question) => question._id === action.questionId)
  const fileIndex = questionsClone[index].files.findIndex((file) => file.id === action.fileId);
  questionsClone[index].files[fileIndex] = {
    ...questionsClone[index].files[fileIndex],
    ...action.file,
  }

  return updateObject(state, {
    questions: questionsClone
  });
}

const deleteFileQuestionServiceForm = (state, action) => {
  const questionsClone = [...state.questions]
  const index = questionsClone.findIndex((question) => question._id === action.questionId)

  if (index < 0) {
    return state
  }

  const filesClone = [...state.questions[index].files]

  const fileIndex = filesClone.findIndex((file) => {
    return file.id === action.fileId || file._id === action.fileId
  })

  if (fileIndex < 0) {
    return state
  }

  filesClone.splice(fileIndex, 1)

  questionsClone[index].files = filesClone

  return updateObject(state, {
    questions: questionsClone
  });
}

const addActionToQuestionServiceForm = (state, action) => {
  const questionsClone = [...state.questions]
  const index = questionsClone.findIndex(question => question._id === action.action.question)
  questionsClone[index].actions.push(action.action)
  return updateObject(state, {
    questions: questionsClone
  });
}

const editActionToQuestionServiceForm = (state, action) => {

  const questionsClone = [...state.questions]
  const index = questionsClone.findIndex(question => question._id === action.action.question)
  const actionIndex = questionsClone[index].actions.findIndex(act => {
    return act._id.toString() === action.actionId.toString()
  })
  questionsClone[index].actions[actionIndex] = { ...action.action, _id: action.actionId };

  return updateObject(state, {
    questions: questionsClone
  });
}

const deleteActionFromQuestionServiceForm = (state, action) => {
  console.log(action.actionId)

  return updateObject(state, {});
};

const deleteActionToQuestionService = (state, action) => {
  const questionsClone = [...state.questions]
  const index = questionsClone.findIndex(question => question._id === action.action.question)
  const actionIndex = questionsClone[index].actions.findIndex(act => {
    return act._id.toString() === action.action._id.toString()
  })
  questionsClone[index].actions[actionIndex] = { ...action.action, _id: action.action._id };
  questionsClone[index].actions.splice(actionIndex, 1);
  return updateObject(state, {
    questions: questionsClone
  });
}

const getOldActionsStart = (state) => {
  return updateObject(state, {
    loadingActions: true,
  })
}

const getOldActionsSuccess = (state, action) => {
  return updateObject(state, {
    loadingActions: false,
    oldActions: action.actions,
  })
}

const getOldActionsFail = (state) => {
  return updateObject(state, {
    loadingActions: false,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SERVICE_FORM_CLEAR_FORM: return clearServiceForm(state, action);
    case actionTypes.SERVICE_FORM_SET_PLACE: return setPlaceServiceForm(state, action);
    case actionTypes.SERVICE_FORM_SET_PLACE_EQUIPMENT: return setPlaceServiceFormEquipment(state, action);
    case actionTypes.SERVICE_FORM_SET_EQUIPMENT: return setEquipmentServiceForm(state, action);
    case actionTypes.SERVICE_FORM_SET_EQUIPMENT_SERVICE: return setEquipmentServiceServiceForm(state, action);
    case actionTypes.SERVICE_FORM_START_POPULATE_QUESTIONS: return populateQuestionsServiceForm(state, action);
    case actionTypes.SERVICE_FORM_START_POPULATE_EDIT_QUESTIONS: return populateEditQuestionsServiceForm(state, action);
    case actionTypes.SERVICE_FORM_SET_DATE: return setDateServiceForm(state, action);
    case actionTypes.SERVICE_FORM_DESCRIPTION: return setDescriptionServiceForm(state, action);
    case actionTypes.SERVICE_FORM_ANSWER_QUESTION: return answerQuestionServiceForm(state, action);
    case actionTypes.SERVICE_FORM_ANSWER_ALL_WITH_NA: return answerAllQuestionWithNA(state);
    case actionTypes.SERVICE_FORM_COMMENT_QUESTION: return commentQuestionServiceForm(state, action);
    case actionTypes.SERVICE_FORM_ADD_FILE_QUESTION: return addFileQuestionServiceForm(state, action);
    case actionTypes.SERVICE_FORM_EDIT_FILE_QUESTION: return editFileQuestionServiceForm(state, action);
    case actionTypes.SERVICE_FORM_DELETE_FILE_QUESTION: return deleteFileQuestionServiceForm(state, action);
    case actionTypes.SERVICE_FORM_ADD_ACTION: return addActionToQuestionServiceForm(state, action);
    case actionTypes.SERVICE_FORM_EDIT_ACTION: return editActionToQuestionServiceForm(state, action);
    case actionTypes.SERVICE_FORM_CHANGE_SITE: return changeSiteServiceForm(state, action);
    case actionTypes.SERVICE_FORM_DELETE_ACTION: return deleteActionFromQuestionServiceForm(state, action);
    case actionTypes.DELETE_ACTION: return deleteActionToQuestionService(state, action);
    case actionTypes.SERVICE_FORM_GET_OLD_ACTIONS_START: return getOldActionsStart(state);
    case actionTypes.SERVICE_FORM_GET_OLD_ACTIONS_SUCCESS: return getOldActionsSuccess(state, action);
    case actionTypes.SERVICE_FORM_GET_OLD_ACTIONS_FAIL: return getOldActionsFail(state);
    default: return state;
  }
};

export default reducer;
